var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Pedidos-Formas-Pago"},[_c('navigation'),_c('pedidos_formas_pago')],1)}
var staticRenderFns = []

export { render, staticRenderFns }